export default class ColorPerFeatureStyleSettingsModule {
    /**
     * 
     * @param styleSettings 
     * @param territoryModel 
     * 
     * @returns 
     */
    getRequiredAttributes(styleSettings, territoryModel): string[] {
        const attrs = [];
        if (styleSettings.enabled) {
            attrs.push('ES_STYLE_COLOR');
        }
        
        return attrs;
    }
}
